import { Component, OnInit } from '@angular/core';
import { ActivityTypes } from '../../../services/audit.service';

@Component({
  selector: 'app-research-portal-stats',
  templateUrl: './research-portal-stats.component.html',
  styleUrls: ['./research-portal-stats.component.scss']
})
export class ResearchPortalStatsComponent implements OnInit {
  selectedActivityTypes: any;

  constructor() {}

  ngOnInit() {}

  seriesClicked(e) {
    this.selectedActivityTypes = e;
  }
}
